// @generated by protoc-gen-es v2.11.0 with parameter "ts_nocheck=true,target=ts"
// @generated from file push.proto (package Push, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file push.proto.
 */
export const file_push: GenFile =
  /*@__PURE__*/
  fileDesc(
    "CgpwdXNoLnByb3RvEgRQdXNoIloKF1VzZXJSZWdpc3RyYXRpb25SZXF1ZXN0EhkKEW1lc3NhZ2VTZXNzaW9uVWlkGAEgASgMEg4KBnVzZXJJZBgCIAEoBRIUCgxlbnRlcnByaXNlSWQYAyABKAUirwEKFUtBVG9QdXNoU2VydmVyUmVxdWVzdBImCgttZXNzYWdlVHlwZRgBIAEoDjIRLlB1c2guTWVzc2FnZVR5cGUSDwoHbWVzc2FnZRgCIAEoCRIZChFtZXNzYWdlU2Vzc2lvblVpZBgDIAEoDBIcChRlbmNyeXB0ZWREZXZpY2VUb2tlbhgEIAMoDBIOCgZ1c2VySWQYBSADKAUSFAoMZW50ZXJwcmlzZUlkGAYgAygFImgKFFdzc0Nvbm5lY3Rpb25SZXF1ZXN0EhkKEW1lc3NhZ2VTZXNzaW9uVWlkGAEgASgMEhwKFGVuY3J5cHRlZERldmljZVRva2VuGAIgASgMEhcKD2RldmljZVRpbWVTdGFtcBgDIAEoAyJMChFXc3NDbGllbnRSZXNwb25zZRImCgttZXNzYWdlVHlwZRgBIAEoDjIRLlB1c2guTWVzc2FnZVR5cGUSDwoHbWVzc2FnZRgCIAEoCSKLAQojUHVzaFNlcnZlckRldmljZVJlZ2lzdHJhdGlvblJlcXVlc3QSHAoUZW5jcnlwdGVkRGV2aWNlVG9rZW4YASABKAwSEQoJcHVzaFRva2VuGAIgASgJEhoKEm1vYmlsZVB1c2hQbGF0Zm9ybRgDIAEoCRIXCg90cmFuc21pc3Npb25LZXkYBCABKAwiRQoKU25zTWVzc2FnZRImCgttZXNzYWdlVHlwZRgBIAEoDjIRLlB1c2guTWVzc2FnZVR5cGUSDwoHbWVzc2FnZRgCIAEoDCp/CgtNZXNzYWdlVHlwZRILCgdVTktOT1dOEAASBwoDRE5BEAESBwoDU1NPEAISCAoEQ0hBVBADEggKBFVTRVIQBBIOCgpFTlRFUlBSSVNFEAUSCgoGS0VFUEVSEAYSCwoHU0VTU0lPThAHEgoKBkRFVklDRRAIEggKBFRPVFAQCWIGcHJvdG8z",
  );

/**
 * @generated from message Push.UserRegistrationRequest
 */
export type UserRegistrationRequest = Message<"Push.UserRegistrationRequest"> & {
  /**
   * @generated from field: bytes messageSessionUid = 1;
   */
  messageSessionUid: Uint8Array;

  /**
   * @generated from field: int32 userId = 2;
   */
  userId: number;

  /**
   * @generated from field: int32 enterpriseId = 3;
   */
  enterpriseId: number;
};

/**
 * Describes the message Push.UserRegistrationRequest.
 * Use `create(UserRegistrationRequestSchema)` to create a new message.
 */
export const UserRegistrationRequestSchema: GenMessage<UserRegistrationRequest> =
  /*@__PURE__*/
  messageDesc(file_push, 0);

/**
 * @generated from message Push.KAToPushServerRequest
 */
export type KAToPushServerRequest = Message<"Push.KAToPushServerRequest"> & {
  /**
   * @generated from field: Push.MessageType messageType = 1;
   */
  messageType: MessageType;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: bytes messageSessionUid = 3;
   */
  messageSessionUid: Uint8Array;

  /**
   * @generated from field: repeated bytes encryptedDeviceToken = 4;
   */
  encryptedDeviceToken: Uint8Array[];

  /**
   * @generated from field: repeated int32 userId = 5;
   */
  userId: number[];

  /**
   * @generated from field: repeated int32 enterpriseId = 6;
   */
  enterpriseId: number[];
};

/**
 * Describes the message Push.KAToPushServerRequest.
 * Use `create(KAToPushServerRequestSchema)` to create a new message.
 */
export const KAToPushServerRequestSchema: GenMessage<KAToPushServerRequest> =
  /*@__PURE__*/
  messageDesc(file_push, 1);

/**
 * @generated from message Push.WssConnectionRequest
 */
export type WssConnectionRequest = Message<"Push.WssConnectionRequest"> & {
  /**
   * @generated from field: bytes messageSessionUid = 1;
   */
  messageSessionUid: Uint8Array;

  /**
   * @generated from field: bytes encryptedDeviceToken = 2;
   */
  encryptedDeviceToken: Uint8Array;

  /**
   * @generated from field: int64 deviceTimeStamp = 3;
   */
  deviceTimeStamp: bigint;
};

/**
 * Describes the message Push.WssConnectionRequest.
 * Use `create(WssConnectionRequestSchema)` to create a new message.
 */
export const WssConnectionRequestSchema: GenMessage<WssConnectionRequest> =
  /*@__PURE__*/
  messageDesc(file_push, 2);

/**
 * @generated from message Push.WssClientResponse
 */
export type WssClientResponse = Message<"Push.WssClientResponse"> & {
  /**
   * @generated from field: Push.MessageType messageType = 1;
   */
  messageType: MessageType;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message Push.WssClientResponse.
 * Use `create(WssClientResponseSchema)` to create a new message.
 */
export const WssClientResponseSchema: GenMessage<WssClientResponse> =
  /*@__PURE__*/
  messageDesc(file_push, 3);

/**
 * @generated from message Push.PushServerDeviceRegistrationRequest
 */
export type PushServerDeviceRegistrationRequest =
  Message<"Push.PushServerDeviceRegistrationRequest"> & {
    /**
     * @generated from field: bytes encryptedDeviceToken = 1;
     */
    encryptedDeviceToken: Uint8Array;

    /**
     * @generated from field: string pushToken = 2;
     */
    pushToken: string;

    /**
     * @generated from field: string mobilePushPlatform = 3;
     */
    mobilePushPlatform: string;

    /**
     * @generated from field: bytes transmissionKey = 4;
     */
    transmissionKey: Uint8Array;
  };

/**
 * Describes the message Push.PushServerDeviceRegistrationRequest.
 * Use `create(PushServerDeviceRegistrationRequestSchema)` to create a new message.
 */
export const PushServerDeviceRegistrationRequestSchema: GenMessage<PushServerDeviceRegistrationRequest> =
  /*@__PURE__*/
  messageDesc(file_push, 4);

/**
 * @generated from message Push.SnsMessage
 */
export type SnsMessage = Message<"Push.SnsMessage"> & {
  /**
   * @generated from field: Push.MessageType messageType = 1;
   */
  messageType: MessageType;

  /**
   * @generated from field: bytes message = 2;
   */
  message: Uint8Array;
};

/**
 * Describes the message Push.SnsMessage.
 * Use `create(SnsMessageSchema)` to create a new message.
 */
export const SnsMessageSchema: GenMessage<SnsMessage> = /*@__PURE__*/ messageDesc(file_push, 5);

/**
 * @generated from enum Push.MessageType
 */
export enum MessageType {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: DNA = 1;
   */
  DNA = 1,

  /**
   * @generated from enum value: SSO = 2;
   */
  SSO = 2,

  /**
   * @generated from enum value: CHAT = 3;
   */
  CHAT = 3,

  /**
   * @generated from enum value: USER = 4;
   */
  USER = 4,

  /**
   * @generated from enum value: ENTERPRISE = 5;
   */
  ENTERPRISE = 5,

  /**
   * @generated from enum value: KEEPER = 6;
   */
  KEEPER = 6,

  /**
   * @generated from enum value: SESSION = 7;
   */
  SESSION = 7,

  /**
   * @generated from enum value: DEVICE = 8;
   */
  DEVICE = 8,

  /**
   * @generated from enum value: TOTP = 9;
   */
  TOTP = 9,
}

/**
 * Describes the enum Push.MessageType.
 */
export const MessageTypeSchema: GenEnum<MessageType> = /*@__PURE__*/ enumDesc(file_push, 0);
